import React, { useContext, useEffect, useMemo, useRef, useState } from 'react'
import ibexLightFullIcon from "../../../images/lightLeftBarIcons/ibexLightFullIcon.png";
import ibexDarkFullIcon from "../../../images/darkLeftBarIcons/ibexDarkFullIcon.png";

import { ThemeContext } from '../../../models/ThemeContext';
import { IAPIPromptsModel, ProjectTypeEnum, ThemeTypes } from '../../../models/SharedModel';
import GlobalLoader from '../../../commonfields/GlobalLoader';
import { Alert, Button, Input, Label, Nav, NavItem, NavLink, TabContent, TabPane } from 'reactstrap';
import { APIS_LIST, DOC_AI_MODE_ENUM, EBOOK_INSIGHTS, IConversationModel, IExtractesDataModel, ITemplateAttributesModel, KB_NAMES_ENUM, PROCESSING_TABS } from '../../../models/ChatModels';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { RoutesEnum } from '../../../models/RoutesModel';
import { getFromSession, removeFromSession, setToSession, text_convert_lower } from '../../../helpers/GenericHelpers';
import Profile from '../../../components/shared/Profile';


import home from "../../../images/darkLeftBarIcons/home.png";
import documentText from "../../../images/darkLeftBarIcons/document-text.png";
import copy from "../../../images/darkLeftBarIcons/copy.png";
import checkmarkCicle from "../../../images/darkLeftBarIcons/checkmark-circle.png";
import listCicle from "../../../images/darkLeftBarIcons/list-circle.png";
import chatIcon from "../../../images/darkLeftBarIcons/chatbox.png";
import configIcon from "../../../images/darkLeftBarIcons/config.png";

import helpCicle from "../../../images/darkLeftBarIcons/help-circle.png";
import settings from "../../../images/darkLeftBarIcons/settings.png";
import logOut from "../../../images/darkLeftBarIcons/log-out.png";

import homeLight from "../../../images/lightLeftBarIcons/home.png";
import documentTextLight from "../../../images/lightLeftBarIcons/document-text.png";
import copyLight from "../../../images/lightLeftBarIcons/copy.png";
import checkmarkCicleLight from "../../../images/lightLeftBarIcons/checkmark-circle.png";
import listCicleLight from "../../../images/lightLeftBarIcons/list-circle.png";
import chatIconLight from "../../../images/lightLeftBarIcons/chatbox.png";
import configIconLight from "../../../images/lightLeftBarIcons/config.png";

import homeChecked from "../../../images/CheckedIcons/home.png";
import documentTextChecked from "../../../images/CheckedIcons/document-text.png";
import copyChecked from "../../../images/CheckedIcons/copy.png";
import checkmarkCicleChecked from "../../../images/CheckedIcons/checkmark-circle.png";
import listCicleChecked from "../../../images/CheckedIcons/list-circle.png";
import chatIconChecked from "../../../images/CheckedIcons/chatbox.png";
import configIconChecked from "../../../images/CheckedIcons/config.png";

import helpCicleLight from "../../../images/lightLeftBarIcons/help-circle.png";
import settingsLight from "../../../images/lightLeftBarIcons/settings.png";
import logOutLight from "../../../images/lightLeftBarIcons/log-out.png";

import uploadInformation from "../../../images/UploadInformation.png";

import { ProjectStatus } from '../../../models/ProjectModel';
import FileUploadContainers from '../../../components/shared/FileUploadContainers';
import RawPdfViewer from '../../../commonfields/RawPdfViewer';
import ChatComponent2 from '../../../components/chat/ChatComponent2';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight, faCheck, faDownload, faFileInvoice, faFilePdf, faList, faPlus, faWarning, faXmark } from '@fortawesome/free-solid-svg-icons';
import { ILogsModel } from '../../../models/LogsModel';
import documentAIService from '../../document_ai/documentAIService';
import { pushToLog } from '../../../helpers/LogHelpers';
import { MainContext } from '../../../models/MainContext';
import { v4 as uuid } from "uuid";
import { toast } from 'react-toastify';
import LogsModal from '../../../components/shared/LogsModal';
import { IKDBProjectInput, IIngestKdbInput, IKeyInfoInput, IDocUserQueryInput, ebook_summarization_v1, summaryPromptType } from '../../../models/APIModels';
import { LOADER_ENUM, LOADER_OPTIONS } from '../../../models/LoaderModel';
import ExtractedData from '../../../components/chat/ExtractedData';
import LoaderHOC from '../../../components/shared/LoaderHOC';
import { downloadWord } from '../../../helpers/DownloadDoxs';
import { downloadPDF } from '../../../helpers/DownloadPdf';
import { ebookSummaryIngestions } from '../../../helpers/ebbokSummaryIngestion';
import DeleteIcon from "../../../images/delete-icon.svg";
import bulbIcon from "../../../images/bulbLight.png";
import bulbDark from "../../../images/bulbDark.png";

import { io } from "socket.io-client";
import { APP_Config } from '../../../helpers/AppConfig';
import CustomDropdown from '../../../commonfields/CustomDropdown';

type Props = {}

const EbookInsightsPage = (props: Props) => {
    const service = new documentAIService();
    const { themeName } = useContext(ThemeContext);

    const images: string[] =
        (themeName === ThemeTypes.DARK_THEME) ?
            [home, documentText, checkmarkCicle, listCicle, copy, chatIcon, helpCicle, settings, logOut, configIcon]
            : [homeLight, documentTextLight, checkmarkCicleLight, listCicleLight, copyLight, chatIconLight, helpCicleLight, settingsLight, logOutLight, configIconLight]

    const checked = [homeChecked, documentTextChecked, checkmarkCicleChecked, listCicleChecked, copyChecked, chatIconChecked, configIconChecked];
    const { projectName, version } = useParams();
    const location = useLocation();
    const projectType = useMemo(
        () => location?.pathname?.split("/")?.[2],
        [location?.pathname]
    );

    const [documentFile, setDocumentFile] = useState<any>();
    const [attributes, setAttributes] = useState<ITemplateAttributesModel[]>([]);
    const [attrModal, setAttrModal] = useState(false);

    const [settingsModal, setSettingsModal] = useState(false);

    const [loader, setLoader] = useState(false);
    const [isDockUploaded, setIsDockUploaded] = useState(false);
    const [conversationList, setConversationList] = useState<IConversationModel[]
    >([]);
    const [mode, setMode] = useState(DOC_AI_MODE_ENUM.SINGLE_DOCUMENT_MODE); // document ai modes
    const [processingTabs, setProcessingTabs] = useState(
        EBOOK_INSIGHTS.DOCUMENT
    );

    const [processingTabs2, setProcessingTabs2] = useState(
        PROCESSING_TABS.DOCUMENT
    );
    const [promtStatus, setPromtStatus] = useState<any>([]);
    const [questionsList, setQuestionsList] = useState([]);
    const [autoTemplate, setAutoTemplate] = useState<any>();
    const [initAttributes, setInitAttributes] = useState<
        ITemplateAttributesModel[]
    >([]);
    const [logsModal, setLogsModal] = useState(false); // modal to get logs
    const [summarizationPrompt, setSummarizationPrompt] = useState("");
    const [validationPrompt, setValidationPrompt] = useState("");
    const [extractedData, setExtractedData] = useState<IExtractesDataModel[]>([]);
    const [dontScroll, setDontScroll] = useState(false);
    const [unique_kdbState, setUnique_kdbState] = useState('');
    const [docType, setDocType] = useState("");
    const [docSummary, setDocSummary] = useState<any>([]);
    const [chatLoader, setChatLoader] = useState(false);
    const [tempAttr, setTempAttr] = useState<ITemplateAttributesModel | null>(
        null
    );
    const [apiModal, setAPIModal] = useState(false);
    const [newModal, setNewModal] = useState(false); // modal to create new project
    const userName = getFromSession('user_name');

    const { modifyLoaders } = useContext(MainContext);

    const toggleAttrModal = () => setAttrModal((prev) => !prev);

    const toggleSettingsModal = () => setSettingsModal((prev) => !prev);

    const toggleLogsModal = () => setLogsModal((prev) => !prev);

    const toggleNewModal = () => setNewModal((prev) => !prev);

    const handleAPIListSuccess = (values: any) => {
        save_prompts(values);
        toggleAPIModal();
    };

    const logout = () => {
        removeFromSession('user_name')
        removeFromSession('user_id')
        navigate(`/${RoutesEnum.LOGIN}`)
    }

    const save_prompts = (data: any) => {
        setLoader(true);
        const kdbName = getFromSession(KB_NAMES_ENUM.KDB_NAME);
        const payload = {
            project_name: projectName,
            project_type: projectType,
            kdbName,
            version,
            project_id: project_main?.project_id,
        };

        service
            .save_prompts(payload as IKDBProjectInput, data)
            .then((res) => {
                toggleAPIModal();
                toast.success(res?.data);
                navigate(`${RoutesEnum.LANDING}/${ProjectStatus.PRODUCTION}`);
                setLoader(false);
                const logData: ILogsModel = {
                    log_id: uuid(),
                    project_id: project_main?.project_id,
                    username: user_id,
                    solution: projectName || "",
                    solution_type: projectType as ProjectTypeEnum,
                    api: "/save_prompts",
                    prompt: "",
                    result: res?.data,
                    tags: [],
                    violations: [],
                    role: "USER",
                    time: new Date(),
                };
                pushToLog(logData);
            })
            .catch((err) => {
                console.log(err);
                setLoader(false);
            });
    };

    const promptsList = useMemo<IAPIPromptsModel[]>(
        () =>
            conversationList
                ?.filter((each) => each?.prompt?.apiCheck)
                ?.map((each2) => ({
                    prompt: each2?.prompt?.value,
                    status: false,
                    type: APIS_LIST.CHATBOT,
                })),
        [conversationList]
    );

    const apiSuccessCallback = () => navigate(`/${RoutesEnum.LANDING}`);


    const handleAPIListCancel = (values: any) => {
        toggleAPIModal();
    };

    const apisList = useMemo<IAPIPromptsModel[]>(
        () => [
            { type: APIS_LIST.VALIDATION, prompt: validationPrompt, status: false },
            {
                type: APIS_LIST.SUMMARIZATION,
                prompt: summarizationPrompt,
                status: false,
            },
            { type: APIS_LIST.DATA_EXTRACTION, prompt: "default", status: false },
        ],
        [validationPrompt, summarizationPrompt]
    );

    const resetAttributes = () => {
        setAttributes(initAttributes || []);
        setTempAttr(null);
    };

    const toggleAPIModal = () => {
        if (!apiModal) {
            save_chat_history(false, 'save_chat_hist')

        }
        setAPIModal((prev) => !prev)
    };

    const clearFields = () => {
        setDocumentFile(null);
        resetFields();
        removeFromSession(KB_NAMES_ENUM.KDB_NAME);
    };

    const resetFields = () => {
        setExtractedData([]);
        setQuestionsList([]);
        setConversationList([]);
        setDocSummary([]);
        setInitAttributes([]);
        setAttributes([]);
        setDocType("");
        setDontScroll(false);
        setSummarizationPrompt('');
        setValidationPrompt('');
    };


    const modifiedData = (values: any) => {
        const keys = Object.keys(values);
        return keys?.map((each) => ({
            dataId: uuid(),
            label: each,
            value: values?.[each],
            flags: [],
            roles: [],
            monitor: false,
            workflows: [],
        }));
    };
    const user_id = getFromSession("user_id");

    const navigate = useNavigate();

    const project_main = useMemo(() => {
        const project_main_raw = getFromSession("project_main");
        if (project_main_raw) return JSON.parse(project_main_raw);
        else return "";
    }, []);


    // display functions
    const displayLogsModal = useMemo(
        () => <LogsModal logsModal={logsModal} toggleLogsModal={toggleLogsModal} />,
        [logsModal]
    );
    const [chatInitiate, setChatInitiate] = useState(false);
    useEffect(() => {
        if (chatInitiate) {
            save_chat_history(true, 'save_chat_hist');
        }
    }, [chatInitiate && conversationList])

    useEffect(() => {
        if ([ProjectStatus.DRAFT, ProjectStatus.WORK_SPACE].includes(project_main?.project_status as ProjectStatus) && documentFile && !isDockUploaded) {
            ebook_summary_ingestion();
            // auto_template()
        }
        else if ((project_main?.project_status === ProjectStatus.PRODUCTION) && documentFile) {
            ebook_summary_ingestion();
        }
    }, [documentFile?.length > 0])

    const validationEnabled = useMemo(() => {
        if ([ProjectStatus.DRAFT, ProjectStatus.WORK_SPACE].includes(project_main?.project_status as ProjectStatus)) {
            return true
        } else {
            // console.log(promtStatus?.find((each: any) => each?.[APIS_LIST.VALIDATION])?.status)
            const validation = promtStatus?.find((each: any) => each?.[APIS_LIST.VALIDATION])
            if (validation?.status) setValidationPrompt(validation?.[APIS_LIST.VALIDATION])
            return validation?.status
        }
    }, [project_main?.project_status, promtStatus])

    const summaryEnabled = useMemo(() => {
        if ([ProjectStatus.DRAFT, ProjectStatus.WORK_SPACE].includes(project_main?.project_status as ProjectStatus)) {
            return true
        } else {
            // console.log(promtStatus?.find((each: any) => each?.[APIS_LIST.SUMMARIZATION])?.status)
            const summary = promtStatus?.find((each: any) => each?.[APIS_LIST.SUMMARIZATION])
            if (summary?.status) setSummarizationPrompt(summary?.[APIS_LIST.SUMMARIZATION])
            return summary?.status
        }
    }, [project_main?.project_status, promtStatus])

    const [fileType, setFileType] = useState();
    const handleDocumentChange = (e: any) => {
        setFileType(e[0]?.type)
        const name = `${KB_NAMES_ENUM.KDB_NAME}_${Math.floor(
            100000 + Math.random() * 900000
        )}`;
        setToSession(KB_NAMES_ENUM.KDB_NAME, name);
        setDocumentFile(e);
        if (e?.length === 0) {
            clearFields();
            setIsDockUploaded(false);
        }
        else {
            if (project_main?.project_status === ProjectStatus.PRODUCTION) {
                api_status_list()
            }
        }
    };

    const api_status_list = () => {
        setLoader(true);
        const kdbName = getFromSession(KB_NAMES_ENUM.KDB_NAME);
        const payload = {
            version,
            project_id: project_main?.project_id,
        };

        service
            .api_status_list(payload as IKDBProjectInput, ProjectStatus.PRODUCTION)
            .then((res) => {
                res?.data?.promt_status.push({
                    "status": true,
                    "docai_upload_file": "docai_upload_file'"
                })
                setPromtStatus(res?.data?.promt_status);
                const chatbot_prompts = res?.data?.promt_status?.find((each: any) => Object.keys(each)?.includes('chatbot_prompts'))?.chatbot_prompts
                setQuestionsList(chatbot_prompts?.filter((each: any) => each?.status));
                setLoader(false);
            })
            .catch((err) => {
                console.log(err);
                setLoader(false);
            });
    };

    // useEffects
    useEffect(() => {
        setLoader(true);
        if (project_main?.project_status === ProjectStatus.PRODUCTION) {
            api_status_list();
            // get_saved_project_info()
        } else {
            if (project_main?.project_id && project_main?.project_id?.length > 0) {
                setTimeout(() => {
                    get_saved_project_info()
                }, 3000)
            }
        }
    }, [project_main?.project_status]);

    const save_chat_history = (loader = true, command: string) => {
        setChatInitiate(false)
        // loader && setLoader(true);
        const kdbName = getFromSession(KB_NAMES_ENUM.KDB_NAME);
        const payload = {
            project_name: projectName,
            project_type: projectType,
            kdbName,
            version,
            project_id: project_main?.project_id,
            chat_history_op: command
        };
        service
            .save_chat_history(payload as IKDBProjectInput, conversationList)
            .then((res) => {
                if (command === 'clear_chat_history') {
                    setConversationList([])
                }
                if (loader) {
                    // toast.success(res?.data?.message)
                    setLoader(false);
                }
            })
            .catch((err) => {
                console.log(err);
                loader && setLoader(false);
            });
    }


    const [summaryData, setSummaryData] = useState<any>([]);
    const summaryModification = (data: any) => {
        setSummaryData(data)
        const topkey: any = Object.keys(data)
        const topvalue: any = Object.values(data)
        console.log(topkey[0])
        const innerKey: any = Object.keys(topvalue[0])
        const innerValue: any = Object.values(topvalue[0])
        console.log(innerKey[0])
        console.log(innerValue[0][0])

        //  setSummary({...summary,"summarization_type":innerKey[0]})
        setDocSummary(innerValue[0])
        //  setting form lables
        handleChange(topkey[0], 'summarization_prompt')
        handleChange(innerKey[0], "summarization_type")
    }

    const get_saved_project_info = () => {
        setLoader(true);
        const kdbName = getFromSession(KB_NAMES_ENUM.KDB_NAME);
        const payload = {
            project_id: project_main?.project_id,
        };
        service.get_saved_project_info(payload as IKDBProjectInput)
            .then((res) => {
                setToSession(KB_NAMES_ENUM.KDB_NAME, res?.data?.kdb_name)
                if ([ProjectStatus.DRAFT, ProjectStatus.WORK_SPACE].includes(project_main?.project_status as ProjectStatus)) {
                    // setDocumentFile([{
                    //   ...res?.data?.document,
                    //   name: res?.data?.document?.path,
                    //   type: res?.data?.document?.path?.split('.')?.[1]
                    // }])
                    if (res?.data?.file_details?.extracted_info?.file_bytes && res?.data?.file_details?.extracted_info?.file_name) {
                        // top_querys_recommender();
                        setIsDockUploaded(true)
                        setDocumentFile([{
                            ...res?.data?.file_details?.extracted_info?.file_bytes,
                            value: res?.data?.file_details?.extracted_info?.file_bytes,
                            name: res?.data?.file_details?.extracted_info?.file_name,
                            path: res?.data?.file_details?.extracted_info?.file_name,
                            type: res?.data?.file_details?.extracted_info?.file_name?.split('.')?.[1]
                        }])
                    }
                    if (res?.data?.ebook_summary !== null) {
                        summaryModification(res?.data?.ebook_summary)
                    }else{
                        summaryModification({
                            "custom_insights": {
                                "compact":null,
                                "comprehensive": null,
                                "standard": null
                            },
                            "extract_topic": {
                                "compact":null,
                                "comprehensive": null,
                                "standard": null
                            },
                            "heading_summary": {
                                "compact":null,
                                "comprehensive": null,
                                "standard": null
                            },
                            "heading_summary_key": {
                                "compact": null,
                                "comprehensive": null,
                                "standard": null
                            }
                        })
                    }
                }
                if ([ProjectStatus.DRAFT, ProjectStatus.WORK_SPACE].includes(project_main?.project_status as ProjectStatus)) {
                    if (res?.data?.chat_history !== null) {
                        setConversationList(res?.data?.chat_history)
                    } else {
                        const id = uuid();
                        setConversationList([
                            {
                                id,
                                prompt: { value: "Hi", time: new Date() },
                                answer: {
                                    value: "Hello! How may I assist you ?",
                                    time: new Date(),
                                },
                            },
                        ])
                    }
                }
                const attrData = res?.data?.modified_json?.attributes
                const attr = attrData?.map(
                    (each: ITemplateAttributesModel) => ({
                        ...each,
                        attributeId: uuid(),
                        examples: each?.examples?.map((each2: any) => {
                            if (typeof each2 === "object") {
                                return each2?.[0];
                            } else return each2;
                        }),
                    })
                );
                setAutoTemplate(res?.data?.modified_json);
                setAttributes(attr);
                setInitAttributes(attr);
                setLoader(false);
                setSummarizationPrompt(res?.data?.summarization_prompt)
                setValidationPrompt(res?.data?.validation_prompt);
                // Setting Extracted info
                if (res?.data?.extracted_info && res?.data?.extracted_info !== null) {
                    let template = Object.keys(res?.data?.extracted_info)[0];
                    const new_data = [ProjectStatus.DRAFT, ProjectStatus.WORK_SPACE].includes(project_main?.project_status as ProjectStatus) && template ?
                        modifiedData(res?.data?.extracted_info[template]) : res?.data?.extracted_info?.map((each: any) => ({ ...each, dataId: uuid() }));
                    setExtractedData(new_data)
                }
                console.log('Response status test')
                console.log(res?.status)
            })
            .catch((err) => {
                // Need to check
                // setIsDockUploaded(false)
                console.log('Response Error test')
                console.log(err);
                setLoader(false);
            });
    }

    const checkEngine = () => {
        return formValues?.model_name && formValues?.model_name.startsWith('gpt') ? 'open_ai' : 'open_source'
    }

    const ebook_summary_ingestion = async () => {
        const kdbName = getFromSession(KB_NAMES_ENUM.KDB_NAME);
        const payload = {
            // files: documentFile,
            files: ([ProjectStatus.DRAFT, ProjectStatus.WORK_SPACE].includes(project_main?.project_status as ProjectStatus) && isDockUploaded) ? undefined : documentFile,
            file_name: (project_main?.project_status === ProjectStatus.PRODUCTION || ([ProjectStatus.DRAFT, ProjectStatus.WORK_SPACE].includes(project_main?.project_status as ProjectStatus) && isDockUploaded)) ? documentFile[0]?.path : undefined,
            project_name: projectName,
            reload: ([ProjectStatus.DRAFT, ProjectStatus.WORK_SPACE].includes(project_main?.project_status as ProjectStatus) && isDockUploaded) ? "True" : "False",
            project_type: projectType,
            kdbName,
            version,
            project_id: project_main?.project_id,
            engine: checkEngine()
        };
        setLoader(true);
        service
            .ebook_summary_ingestion(payload as IIngestKdbInput, project_main?.project_status)
            .then((res) => {
                // knowledgebase_summarization();
                const id = uuid();
                if (project_main?.project_status !== ProjectStatus.PRODUCTION) {
                    // auto_template()
                }
                setDontScroll(false);
                if (project_main?.project_status === ProjectStatus.PRODUCTION) {
                    setUnique_kdbState(res.data.unique_kdb)
                    setToSession(KB_NAMES_ENUM.UNIQUE_KDB, res.data.unique_kdb)
                    docai_draft_keyinfo_ext(res.data.unique_kdb);
                    setConversationList([
                        {
                            id,
                            prompt: { value: "Hi", time: new Date() },
                            answer: {
                                value: "Hello! How may I assist you ?",
                                time: new Date(),
                            },
                        },
                    ])
                } else {
                    // top_querys_recommender();
                    if (![ProjectStatus.DRAFT, ProjectStatus.WORK_SPACE].includes(project_main?.project_status as ProjectStatus) && isDockUploaded || conversationList.length == 0) {
                        setConversationList([
                            {
                                id,
                                prompt: { value: "Hi", time: new Date() },
                                answer: {
                                    value: "Hello! How may I assist you ?",
                                    time: new Date(),
                                },
                            },
                        ]);
                    }
                }
                setLoader(false);
                const logData: ILogsModel = {
                    log_id: uuid(),
                    project_id: project_main?.project_id,
                    username: user_id,
                    solution: projectName || "",
                    solution_type: projectType as ProjectTypeEnum,
                    api: "/docai_ingest_kdb",
                    prompt: "",
                    result: "",
                    tags: [],
                    violations: [],
                    role: "USER",
                    time: new Date(),
                };
                pushToLog(logData);
            })
            .catch((err) => {
                console.log(err);
                setLoader(false);
            });
    };

    const docai_draft_keyinfo_ext = (unq_kdb: string, template?: string) => {
        modifyLoaders(LOADER_ENUM.EXTRACTED_DETAILS, LOADER_OPTIONS.ADD);
        const kdbName = getFromSession(KB_NAMES_ENUM.KDB_NAME);
        const payload = {
            // check for file exist
            // files: documentFile,
            files: ([ProjectStatus.DRAFT, ProjectStatus.WORK_SPACE].includes(project_main?.project_status as ProjectStatus) && isDockUploaded) ? undefined : documentFile,
            version,
            unique_kdb: project_main?.project_status === ProjectStatus.PRODUCTION ? unq_kdb : undefined,
            kdbName: [ProjectStatus.DRAFT, ProjectStatus.WORK_SPACE].includes(project_main?.project_status as ProjectStatus) ? kdbName : undefined,
            project_id: project_main?.project_id,
            project_name: projectName,
            file_name: (project_main?.project_status === ProjectStatus.PRODUCTION || ([ProjectStatus.DRAFT, ProjectStatus.WORK_SPACE].includes(project_main?.project_status as ProjectStatus) && isDockUploaded)) ? documentFile[0]?.path : undefined,
            ...([ProjectStatus.DRAFT, ProjectStatus.WORK_SPACE].includes(project_main?.project_status as ProjectStatus) ? {
                project_name: projectName,
                project_type: projectType,
                template,
                reload: ([ProjectStatus.DRAFT, ProjectStatus.WORK_SPACE].includes(project_main?.project_status as ProjectStatus) && isDockUploaded) ? "True" : "False",
            } : {})
        };
        service
            .docai_draft_keyinfo_ext(payload as IKeyInfoInput, project_main?.project_status)
            .then((res) => {
                const new_data =
                    [ProjectStatus.DRAFT, ProjectStatus.WORK_SPACE].includes(project_main?.project_status as ProjectStatus) && template ?
                        modifiedData(res?.data?.[template]) :
                        res?.data?.map((each: any) => ({ ...each, dataId: uuid() }))
                    ;
                setExtractedData(new_data);
                const logData: ILogsModel = {
                    log_id: uuid(),
                    project_id: project_main?.project_id,
                    username: user_id,
                    solution: projectName || "",
                    solution_type: projectType as ProjectTypeEnum,
                    api: "/docai_draft_keyinfo_ext",
                    prompt: "",
                    result: JSON.stringify(new_data),
                    tags: [],
                    violations: [],
                    role: "USER",
                    time: new Date(),
                };
                pushToLog(logData);
                modifyLoaders(LOADER_ENUM.EXTRACTED_DETAILS, LOADER_OPTIONS.REMOVE);
            })
            .catch((err) => {
                console.log(err);
                modifyLoaders(LOADER_ENUM.EXTRACTED_DETAILS, LOADER_OPTIONS.REMOVE);
            });
    };

    //     "custome_prompt": "custom prompt",
    //     "summarization_type": "standard",
    //     "summarization_prompt": "chapter"
    // }   
    const updateLists = (summaryData: any, responseData: any) => {
        console.log('we are here')
        const updatedObj = { ...summaryData }; // Create a shallow copy of the object
        for (const key in updatedObj) {
            const value = updatedObj[key];
            if (value && typeof value === 'object') {
                for (const innerKey in value) {
                    console.log('test values')
                    console.log(summaryData[key][innerKey])
                    console.log(key, innerKey)
                    console.log(summary?.summarization_prompt, summary?.summarization_type)
                    if (key === summary?.summarization_prompt && innerKey === summary?.summarization_type) {
                        updatedObj[key][innerKey] = responseData;
                    }
                }
            }
        }
        console.log(updatedObj)
        setSummaryData(updatedObj); // Update state with the modified object
        setEndFlag(false)
        return updatedObj; // Return the modified object
    }
    // warning text while running summarization
    const [summaryWarn, setSummaryWarn] = useState(false);
    const knowledgebase_summarization = async () => {
        // const payload = {
        //     project_name: projectName,
        //     project_type: projectType,
        //     version,
        //     summarization_prompt: summary?.summarization_prompt,
        //     project_id: project_main?.project_id,
        //     summarization_type: summary?.summarization_type,
        //     custome_prompt: summary?.custome_prompt
        // };
        const payload: any = ebookSummaryIngestions(summary?.summarization_prompt, summary?.summarization_type, project_main?.project_id, summary?.custome_prompt ? summary?.custome_prompt : 'None');
        payload.engine = checkEngine();
        setSummaryWarn(true)
        setDocSummary([])
        service
            .ebook_summarization_v1(payload as ebook_summarization_v1)
            .then((res) => {
                // setDocSummary(["test data", "test Data"]);                
                // updateLists(summaryData, ["test data", "test Data"])
                const logData: ILogsModel = {
                    log_id: uuid(),
                    project_id: project_main?.project_id,
                    username: user_id,
                    solution: projectName || "",
                    solution_type: projectType as ProjectTypeEnum,
                    api: "/ebook_summarization",
                    prompt: summarizationPrompt,
                    result: res?.data || "",
                    tags: [],
                    violations: [],
                    role: "USER",
                    time: new Date(),
                };
                pushToLog(logData);
            })
            .catch((err) => {
                console.log(err);
                setSummaryWarn(false)
            });
    };

    const [recommendedPrompts, setRecommendedPrompts] = useState([])
    const displayRecomendedPrompts = () => {
        return recommendedPrompts?.map((each: any, index: number) => {
            return (
                <>
                    {each?.length > 0 && <option value={each} key={index}
                    >
                        <div style={{ textOverflow: 'ellipsis' }}>{text_convert_lower(each)}</div>
                    </option>}
                </>
            );
        });
    }
    const ebooktop_recommended_prompts = () => {
        modifyLoaders(LOADER_ENUM.SUMMARY_RECOMENDATIONS, LOADER_OPTIONS.ADD);
        const payload = {
            project_id: project_main?.project_id,
            // input_prompt:summary?.custome_prompt
            query_text: summary?.custome_prompt
        }
        service.ebooktop_recommended_prompts(payload).then((response: any) => {
            console.log(response?.data)
            setRecommendedPrompts(response?.data);
            modifyLoaders(LOADER_ENUM.SUMMARY_RECOMENDATIONS, LOADER_OPTIONS.REMOVE);
        }).catch(error => {
            console.log(error)
        })
    }

    const gpt_vision = (prompt: string, id: any) => {
        const formData = new FormData();
        if ((fileType === 'image/jpeg') || (fileType === 'image/png')) {
            var blobed = new Blob(documentFile, { type: fileType });
            formData.append('files', blobed, 'image.png');
        }
        //  else {
        //   formData.append('files', croppedImageBlob, 'image.png');
        // }
        formData.append('query', prompt);
        // const id = uuid();
        console.log('Primary Id ')
        // console.log(id)
        if ((fileType === 'image/jpeg') || (fileType === 'image/png')) {
            service.gpt_vision(formData)
                .then(res => {
                    setConversationList((prev) =>
                        prev?.map((each) => {
                            if (each?.id === id) {
                                return {
                                    ...each,
                                    answer: {
                                        value: res?.data?.analysis_result || "Something went wrong",
                                        time: new Date(),
                                    },
                                };
                            } else return each;
                        })
                    );
                    setChatInitiate(true);
                    setChatLoader(false);
                })
                .catch(err => console.log(err))
        }
    }

    const question_answer = async (prompt: string | any, init = false) => {
        let promptKey: any = 1
        promptKey = Object.keys(prompt)?.find(str => str?.includes('prompt'))
        setChatLoader(true);
        setDontScroll(false);
        const id = uuid();
        const new_conversation = init ? [] : conversationList;
        setConversationList([
            ...new_conversation,
            { id, prompt: { value: project_main?.project_status === ProjectStatus.PRODUCTION ? prompt[promptKey] : prompt, time: new Date() } },
        ]);

        //  { id, prompt: { value: (prompt as value), time: new Date() } },

        const kdbName = getFromSession(KB_NAMES_ENUM.KDB_NAME);
        const payload = {
            project_name: projectName,
            project_type: projectType,
            query: prompt,
            fileName: documentFile?.[0]?.path?.split(".")?.[0],
            kdbName,
            version,
            project_id: project_main?.project_id,
            engine: checkEngine()
        };

        const unique_kdb = unique_kdbState
        const produtionPayload = {
            project_name: projectName,
            project_type: projectType,
            prompt: promptKey,
            prompt_query: prompt[promptKey],
            fileName: documentFile?.[0]?.path?.split(".")?.[0],
            unique_kdb: unique_kdb,
            version,
            project_id: project_main?.project_id,
            engine: checkEngine()
        }
        // project_main?.project_status === ProjectStatus.PRODUCTION

        // remove query add prompt as key  --- 
        if (project_main?.project_status === ProjectStatus.PRODUCTION) {
            if ((fileType === 'image/jpeg') || (fileType === 'image/png')) {
                gpt_vision(prompt, id)
            } else {
                service
                    .ebook_userquery(produtionPayload as IDocUserQueryInput, project_main?.project_status)
                    .then((res) => {
                        setConversationList((prev) =>
                            prev?.map((each) => {
                                if (each?.id === id) {
                                    return {
                                        ...each,
                                        answer: {
                                            value: res?.data?.result || "Something went wrong",
                                            time: new Date(),
                                        },
                                    };
                                } else return each;
                            })
                        );
                        setChatInitiate(true)
                        const logData: ILogsModel = {
                            log_id: uuid(),
                            project_id: project_main?.project_id,
                            username: user_id,
                            solution: projectName || "",
                            solution_type: projectType as ProjectTypeEnum,
                            api: "/docai_get_userquery",
                            prompt,
                            result: JSON.stringify(res?.data),
                            tags: [],
                            violations: [],
                            role: "USER",
                            time: new Date(),
                        };
                        console.log('chat test chat')
                        save_chat_history(true, 'save_chat_hist');
                        pushToLog(logData);
                        setChatLoader(false);
                    })
                    .catch((err) => {
                        console.log(err);
                        setChatLoader(false);
                    });
            }
        } else {
            if ((fileType === 'image/jpeg') || (fileType === 'image/png')) {
                gpt_vision(prompt, id)
            } else {
                service
                    .ebook_userquery(payload as IDocUserQueryInput, project_main?.project_status)
                    .then((res) => {
                        setConversationList((prev) =>
                            prev?.map((each) => {
                                if (each?.id === id) {
                                    return {
                                        ...each,
                                        answer: {
                                            value: res?.data?.result || "Something went wrong",
                                            time: new Date(),
                                        },
                                    };
                                } else return each;
                            })
                        );
                        setChatInitiate(true)
                        const logData: ILogsModel = {
                            log_id: uuid(),
                            project_id: project_main?.project_id,
                            username: user_id,
                            solution: projectName || "",
                            solution_type: projectType as ProjectTypeEnum,
                            api: "/ebook_userquery",
                            prompt: project_main?.project_status === ProjectStatus.PRODUCTION ? prompt[promptKey] : prompt,
                            result: JSON.stringify(res?.data),
                            tags: [],
                            violations: [],
                            role: "USER",
                            time: new Date(),
                        };
                        pushToLog(logData);
                        setChatLoader(false);
                    })
                    .catch((err) => {
                        console.log(err);
                        setChatLoader(false);
                    });
            }
        }
    };

    const tabProcess = () => {
        if (processingTabs === EBOOK_INSIGHTS.SUMMARIZATION) {
            return EBOOK_INSIGHTS.SUMMARIZATION;
        }
    }

    const [formValues, setFormValues] = useState<any>(
        {
            temparature: 0.1,
            chunk_overlap: 250,
            chunk_size: 250
        })

    const addConfig = (data: any) => {
        const finalData = { ...data, project_id: project_main?.project_id }
        service?.add_project_configuration(finalData).then((response: any) => {
            response?.data && toast.success(response?.data);
            // toggleSettingsModal()
        }).catch((error: any) => {
            console.log(error)
            toast.error('something went wrong')
        })
    }

    useEffect(() => {
        getConfig(project_main?.project_id)
    }, [project_main?.project_id])

    const getConfig = (projectId: string) => {
        const data = { project_id: projectId }
        service?.get_project_configuration_details(data).then((res: any) => {
            const resdata = {
                "chunk_overlap": res?.data?.chunk_overlap,
                "chunk_size": res?.data?.chunk_size,
                "model_name": res?.data?.model_name,
                "open_ai_key": res?.data?.open_ai_key,
                "temperature": res?.data?.temperature
            }
            setFormValues(resdata);
            console.log(resdata)
        }).catch((error: any) => {
            console.log(error)
        })
    }

    // Doc Ai content added updates are here
    const removeFile = (e: any) => {
        e?.stopPropagation();
        setAttributes([]);
        setInitAttributes([]);
        setIsDockUploaded(false)
    };

    const execute = () => {
        ebook_summary_ingestion();
        // auto_template()
    };

    const dataExtractionEnabled = useMemo(() => {
        if (project_main?.project_status === ProjectStatus.DRAFT) {
            return true
        } else {
            // console.log(promtStatus?.find((each: any) => each?.[APIS_LIST.DATA_EXTRACTION])?.status)
            return promtStatus?.find((each: any) => each?.[APIS_LIST.DATA_EXTRACTION])?.status
        }
    }, [project_main?.project_status, promtStatus])

    const handleAttribute = (value: ITemplateAttributesModel) => {
        setTempAttr(value);
        toggleAttrModal();
    };

    const downloadChat = () => {
        const element = document.createElement("a");
        const newData = conversationList?.map(
            (each) =>
                `User: ${each?.prompt?.value
                    ?.trimStart()
                    ?.trimEnd()}\nResponse: ${each?.answer?.value
                        ?.trimStart()
                        ?.trimEnd()}\n\n`
        );
        const file = new Blob(newData, { type: "text/plain" });
        element.href = URL.createObjectURL(file);
        element.download = "chat.txt";
        document.body.appendChild(element);
        element.click();
    };

    // const summarization = {
    //     enableSummarization: true,
    //     knowledgebase_summarization: knowledgebase_summarization,
    // };

    const singleView = () => <RawPdfViewer file={documentFile?.[0]} />

    const summaryPromptTypes = [{ label: 'Highlighted Summary', value: summaryPromptType?.heading_summary },
    { label: 'Summary with key Highlights', value: summaryPromptType?.heading_summary_key }, { label: 'topic wise summarization', value: summaryPromptType?.extract_topic }
        , { label: 'Custom Summary', value: summaryPromptType?.custom_insights }]
    //     Chapter-wise Summarizatio
    // key Highlighted Insights
    const summaryTypes = ['compact', 'standard', 'comprehensive']

    const displaySummaryPromptTypes = () => {
        return summaryPromptTypes?.map((each: any, index: number) => {
            return (
                <option value={each?.value ? each?.value : each} key={index}>
                    {text_convert_lower(each?.label ? each?.label : each)}
                </option>
            );
        });
    }

    const [summary, setSummary] = useState<any>({ custome_prompt: '', summarization_type: 'compact' })
    const handleChange = (value: any, field: string) => {
        setSummary((prev: any) => ({
            ...(prev ?? {}),
            [field]: value || "",
        }));
    };

    const summaryDisabled = () => {
        if (summary?.summarization_type?.length > 0 && summary?.summarization_prompt?.length > 0
            // && summary?.summarization_prompt !== 'custome_insights'
        ) {
            return false
        }
        return true
    }

    useEffect(() => {
        summarySetUP()
    }, [summary])


    const summarySetUP = () => {
        // if(summary?.summarization_prompt === "custome_insights"){
        //     setDocSummary(summaryData['custome_prompt'][summary?.summarization_type])
        // }
        summaryData[summary?.summarization_prompt] && setDocSummary(summaryData[summary?.summarization_prompt][summary?.summarization_type])
        // {
        //     "custome_prompt": "custom prompt",
        //     "summarization_type": "standard",
        //     "summarization_prompt": "chapter"
        // }
        return null
    }

//     const URL_WEB_SOCKET = 'ws://localhost:5000/';
//   useEffect(() => {
//     const socket = io(URL_WEB_SOCKET);

//     socket.on('connect', () => {
//         console.log('Connected to WebSocket server');
//       });
  
//       // words
//       socket.on('numbers', (data:any) => {
//         setEndFlag(false)
//         // Update the state by appending new data to the existing list
//         setInfo((prevDataList:any) => [...prevDataList, data]);
//         setDocSummary((docSummary: any) => [...docSummary, data]);
//         console.log('Received message from server:', data);
//         if(data === '\nTHANK YOU!!!'){
//             setEndFlag(true)
//         }
//       });
  
//       socket.on('disconnect', () => {
//         console.log('Disconnected from WebSocket server');
//       });
  
//       return () => {
//         socket.disconnect();
//       };
//     },[])

    const [endFlag, setEndFlag] = useState(false)
    useEffect(()=>{
        updateLists(summaryData, [docSummary])
        console.log('############## Updates ##########################')
    },[endFlag])

    const [connTrail, setConnTrail] = useState(true)
    useEffect(() => {
        const URL_WEB_SOCKET = APP_Config()?.REACT_APP_AI_SOCKET_URL;

        const socket = io(URL_WEB_SOCKET);

        // Event handlers
        socket.on('connect', () => {
            console.log('Connected to WebSocket server');
            setConnTrail(false)
        });

        // // words
        socket.on('words', (data: any) => {
            // Update the state by appending new data to the existing list
            //   setInfo((prevDataList:any) => [...prevDataList, data]);
            setDocSummary((docSummary: any) => [...docSummary, data]);
            if(data === '\nTHANK YOU!!!'){
                setEndFlag(true)
                setSummaryWarn(false)
            }
            // updateLists(summaryData, [...docSummary, data])
            console.log('Received message from server:', data);
        });

        socket.on('disconnect', () => {
            console.log('Disconnected from WebSocket server');
        });

    }, []);

    const bottomRef = useRef<null | HTMLDivElement>(null);

    useEffect(() => {
          bottomRef?.current &&
          bottomRef?.current?.scrollIntoView({
            behavior: "smooth",
            block: "nearest",
            inline: "start",
          });
      }, [docSummary]);

    const [disableAction, setDisableAction] = useState(true)
    return (
        <div className={`solition-studio ${themeName === ThemeTypes?.BLUE_THEME ? 'bright' : ''}`}>
            {loader ? <GlobalLoader /> : <></>}
            <div className='left-menu'>
                <div className='header'>
                    <img src={themeName === ThemeTypes?.BLUE_THEME ? ibexLightFullIcon : ibexDarkFullIcon} alt='Ibex' />
                </div>
                <div className='menu'>
                    <div className='top-menu'>
                        <Nav pills>
                            <div className='item home'>
                                <NavItem>
                                    <NavLink
                                        className={
                                            processingTabs === EBOOK_INSIGHTS.DASHBOARD
                                                ? "active"
                                                : ""
                                        }
                                        // onClick={() => setProcessingTabs(EBOOK_INSIGHTS.DASHBOARD)}
                                        onClick={() => navigate(`${RoutesEnum.LANDING}`)}
                                    >
                                        <img src={images[0]} alt="Home" /><div className='text'>Dashboard </div>
                                    </NavLink>
                                </NavItem>
                            </div>
                            <div className='item'>
                                <NavItem>
                                    <NavLink
                                        className={
                                            processingTabs === EBOOK_INSIGHTS.DOCUMENT
                                                ? "active"
                                                : ""
                                        }
                                        onClick={() => setProcessingTabs(EBOOK_INSIGHTS.DOCUMENT)}
                                    >
                                        <img src={processingTabs === EBOOK_INSIGHTS.DOCUMENT ? checked[1] : images[1]} alt="Home" /><div className='text'>Document</div>
                                    </NavLink>
                                </NavItem>
                            </div>
                            <div className='item'>
                                <NavItem>
                                    <NavLink
                                        className={
                                            processingTabs === EBOOK_INSIGHTS.SUMMARIZATION
                                                ? "active"
                                                : ""
                                        }
                                        onClick={() => setProcessingTabs(EBOOK_INSIGHTS.SUMMARIZATION)}
                                    // disabled={!summaryEnabled}
                                    >
                                        <img src={processingTabs === EBOOK_INSIGHTS.SUMMARIZATION ? checked[3] : images[3]} alt="Home" /><div className='text'>Summarization</div>
                                    </NavLink>
                                </NavItem>
                            </div>
                            <div className='item'>
                                <NavItem>
                                    <NavLink
                                        className={
                                            processingTabs === EBOOK_INSIGHTS.CHATBOT
                                                ? "active"
                                                : ""
                                        }
                                        onClick={() => setProcessingTabs(EBOOK_INSIGHTS.CHATBOT)}
                                    >
                                        <img src={processingTabs === EBOOK_INSIGHTS.CHATBOT ? checked[5] : images[5]} alt="Home" /><div className='text'>ChatAi</div>
                                    </NavLink>
                                </NavItem>
                            </div>
                            {/* <div className='item'>
                    <NavItem>
                      <NavLink
                        className={
                          processingTabs === EBOOK_INSIGHTS.CONFIGURE_PREFERENCES
                            ? "active"
                            : ""
                        }
                        onClick={() => setProcessingTabs(EBOOK_INSIGHTS.CONFIGURE_PREFERENCES)}
                      >
                        <img src={processingTabs === EBOOK_INSIGHTS.CONFIGURE_PREFERENCES ? checked[6] :images[9]} alt="Home" /><div className='text'>Configure&nbsp;Preferences</div>
                      </NavLink>
                    </NavItem>
                  </div> */}
                            {/* <div className='item'>
                    <NavItem>
                      <NavLink
                        className={
                          processingTabs === EBOOK_INSIGHTS.TEST_QUERY
                            ? "active"
                            : ""
                        }
                        onClick={() => setProcessingTabs(EBOOK_INSIGHTS.TEST_QUERY)}
                      >
                        <img src={processingTabs === EBOOK_INSIGHTS.TEST_QUERY ? checked[6] :images[9]} alt="Home" /><div className='text'>Query</div>
                      </NavLink>
                    </NavItem>
                  </div> */}
                        </Nav>
                    </div>
                    <div className='footer-menu'>
                        <div className='item'><img src={images[6]} alt="Home" /><div className='text'>Help</div></div>
                        <div className='item' onClick={() => toggleSettingsModal()}><img src={images[7]} alt="Home" /><div className='text'>Settings</div></div>
                        <div className='item' onClick={() => logout()}><img src={images[8]} onClick={() => logout()} alt="Home" /><div className='text'>Logout</div></div>
                        {/* <div className='item'><img className='iconImg' src={user} alt="Home" /><div className='text'>{userName}</div></div> */}
                        <div className='item'>
                            {/* <img className='iconImg' src={user} alt="Home"/> */}
                            <Profile />
                            <div className='text'>{userName}</div></div>
                        {/* <Profile /> */}
                    </div>
                </div>
            </div>
            <div className='page-body'>
                <div className='project-header'>
                    <div>{projectName}</div>
                </div>
                <TabContent activeTab={processingTabs}>
                    <TabPane tabId={EBOOK_INSIGHTS.DOCUMENT}>
                        <div className='pane-content'>
                            <div className='child child3'>
                                {documentFile !== undefined ?? <div className='header'>Document Viewer</div>}
                                <div className='document'>
                                    <FileUploadContainers
                                        files={documentFile}
                                        handleFileChange={handleDocumentChange}
                                        btnlabel={
                                            <div className='labels'>
                                                <img src={uploadInformation} alt="upload" /><div className='text'><u>Click to Upload</u><br></br>or
                                                    <br></br>drag and drop</div>
                                            </div>
                                        }
                                        displayFilesContent={true}
                                        displayInput={!documentFile || documentFile?.length < 1}
                                        accept={{
                                            "application/pdf": [".pdf"],
                                            "image/jpeg": [".jpeg", ".jpg"],
                                            "image/png": [".png"],
                                        }}
                                        maxFiles={
                                            mode === DOC_AI_MODE_ENUM.SINGLE_DOCUMENT_MODE ? 1 : 20
                                        }
                                    />
                                    {documentFile ? (
                                        <>
                                            {singleView()}
                                        </>
                                    ) : (
                                        <div className="not-found">No Document to display</div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </TabPane>
                    <TabPane
                        tabId={tabProcess()}
                    // tabId={processingTabs === EBOOK_INSIGHTS.VALIDATION ? EBOOK_INSIGHTS.VALIDATION : (EBOOK_INSIGHTS.SUMMARIZATION ? EBOOK_INSIGHTS.SUMMARIZATION : EBOOK_INSIGHTS.TEMPLATE )}
                    >
                        <div className='pane-content'>
                            <div className='child'>
                                <div className='document-validation'>
                                    {documentFile ? (
                                        singleView()
                                    ) : (
                                        <div className="not-found">No Document to display</div>
                                    )}
                                </div>
                            </div>
                            <div className='child'>
                                {processingTabs === EBOOK_INSIGHTS.SUMMARIZATION ?
                                    <div className='validation'>
                                        <div className="label-box">
                                            <Label for="validationPrompt">SUMMARY</Label>
                                            {/* <Button disabled={!(summary?.summarization_type?.length>0 && summary?.summarization_prompt?.length>0)} className="to-prod-btn" onClick={knowledgebase_summarization}>Get Summary</Button> */}
                                            <div>
                                                <Button style={{ backgroundColor: '#005D74', marginRight: '5px' }} onClick={() => downloadPDF(docSummary, projectName)} disabled={docSummary?.length <= 0}><FontAwesomeIcon icon={faFilePdf} /></Button>
                                                {/* <Button style={{ backgroundColor: '#005D74', marginRight: '5px' }} onClick={() => downloadWord(docSummary, projectName)} disabled={docSummary?.length <= 0}><FontAwesomeIcon icon={faDownload} /></Button> */}
                                                <Button style={{ backgroundColor: '#005D74' }} onClick={knowledgebase_summarization} disabled={summaryDisabled() || summaryWarn}><FontAwesomeIcon icon={faList} /></Button>
                                            </div>
                                        </div>
                                        <div className='summary-options' >
                                            <div>
                                                {/* <Label for="eproject-type">Solution Type<span className='required'>*</span></Label> */}
                                                <Input
                                                    id="summarization-prompt"
                                                    name="summarization-prompt"
                                                    type="select"
                                                    value={summary?.summarization_prompt}
                                                    disabled={summaryWarn}
                                                    onChange={(e) => handleChange(e?.target?.value, "summarization_prompt")}
                                                >
                                                    <option value={""}>Select Summarization type</option>
                                                    {displaySummaryPromptTypes()}
                                                </Input>
                                            </div>

                                            {/* <Label for="eproject-type">Length</Label> */}
                                            <div className='summary-type'>
                                                {summary?.summarization_prompt !== summaryPromptType?.extract_topic &&
                                                    summary?.summarization_prompt !== summaryPromptType?.custom_insights
                                                    && summaryTypes?.map((ele: any, index: number) => (
                                                        <div key={index}>
                                                            <label className={`${(ele == summary?.summarization_type) ? 'checked' : ''} `}>
                                                                {ele}
                                                                <input
                                                                    type='radio'
                                                                    value={ele} // Set the value to the label value
                                                                    name='summarization_type'
                                                                    disabled={summaryWarn}
                                                                    onChange={(e) => handleChange(e.target.value, "summarization_type")}
                                                                />
                                                            </label>
                                                        </div>
                                                    ))}
                                            </div>
                                            {/* <Button className="to-prod-btn" onClick={knowledgebase_summarization}>Get Summary</Button> */}

                                            {/* <div className='summary-Generator'>
                                                <FontAwesomeIcon icon={faList} onClick={knowledgebase_summarization} />
                                            </div> */}
                                        </div>
                                        <div 
                                        style={{display:'flex'}}
                                        >
                                        {(summary?.summarization_prompt?.length > 0 && summary?.summarization_prompt == summaryPromptType?.extract_topic || summary?.summarization_prompt?.length > 0 && summary?.summarization_prompt == summaryPromptType?.custom_insights)
                                            && 
                                            
                                        <Input value={summary?.custome_prompt} placeholder='Please enter prompt' style={{ marginTop: '10px' }} type='text' onChange={(e) => handleChange(e?.target?.value, "custome_prompt")} />}

                                            {/* <div style={{ display: 'flex', justifyContent: "flex-end" }}> */}
                                            {(summary?.summarization_prompt?.length > 0 && summary?.summarization_prompt?.length > 0 && summary?.summarization_prompt == summaryPromptType?.custom_insights)
                                                && summary?.custome_prompt.length>0 &&
                                            
                                                <button  style={{backgroundColor:'transparent', border:'none'}}
                                                >
                                                <img onClick={() => ebooktop_recommended_prompts()} src={themeName === ThemeTypes?.BLUE_THEME ? bulbDark : bulbIcon} alt="test" className='recomendbulb'/>
                                                </button>
                                            }
                                            {/* </div> */}
                                        </div>
                                        {LoaderHOC(
                                            <>
                                                {recommendedPrompts?.length > 0 && summary?.summarization_prompt?.length > 0 && summary?.summarization_prompt == summaryPromptType?.custom_insights
                                                    &&
                                                    <>
                                                    {/* <Input
                                                        id="summarization-prompt"
                                                        name="summarization-prompt"
                                                        type="select"
                                                        value={summary?.custome_prompt}
                                                        disabled={summaryWarn}
                                                        style={{marginTop:'10px'}}
                                                        onChange={(e) => handleChange(e?.target?.value, "custome_prompt")}
                                                    >
                                                        <option value={""}>Select Recomended type</option>
                                                        {displayRecomendedPrompts()}
                                                    </Input> */}
                                                    <CustomDropdown options={recommendedPrompts} onSelect={
                                                        (option:any) => handleChange(option, "custome_prompt")
                                                    } 
                                                    />
                                                    </>
                                                }
                                            </>
                                            ,
                                            LOADER_ENUM.SUMMARY_RECOMENDATIONS
                                        )}
                                        <br></br>

                                        {summaryWarn && <div style={{ fontSize: '13px', display: 'flex', textAlign: 'center', color: '#e4b607', flexDirection: 'column' }}>
                                            <div>Note: Summarizing a longer document may take some time. Please hold on while we process your request.</div>
                                            <div> Thank you for your patience.</div>

                                            <FontAwesomeIcon icon={faWarning} />
                                        </div>}
                                        {/* <Button disabled={!(summary?.summarization_type?.length>0 && summary?.summarization_prompt?.length>0)} className="to-prod-btn" onClick={knowledgebase_summarization}>Get Summary</Button> */}
                                        {/* {JSON.stringify()} */}
                                        {docSummary
                                            ? <><div className='summary summaryEbook'>{docSummary}<div ref={bottomRef} /></div></>
                                            : (summaryWarn ? "" : "No data available")
                                        }
                                        <br></br>
                                        {/* <div className="production">
                                            {project_main?.project_status?.toLocaleLowerCase() ===
                                                "production" ? (
                                                <Button className="to-prod-btn" onClick={toggleNewModal}>
                                                    CREATE VERSION
                                                </Button>
                                            ) : (
                                                <Button className="to-prod-btn" onClick={toggleAPIModal}>
                                                    RELEASE TO PRODUCTION{" "}
                                                    <FontAwesomeIcon icon={faArrowRight} />
                                                </Button>
                                            )}
                                        </div> */}

                                    </div> : ""}
                            </div>
                        </div>
                    </TabPane>
                    <TabPane tabId={EBOOK_INSIGHTS.CHATBOT}>
                        <div className='pane-content'>
                            <div className='child'>
                                <div className='document-validation'>
                                    {documentFile ? (
                                        singleView()
                                    ) : (
                                        <div className="not-found">No Document to display</div>
                                    )}
                                </div>
                            </div>
                            <div className='child child2'>
                                <div className='chat-assist'>
                                    <div className='chat-header'>
                                        <div>iBex Chat Assistant</div>

                                        <div>{project_main?.project_status?.toLocaleLowerCase() === ProjectStatus.PRODUCTION ? (
                                            <Button className="view-api" onClick={toggleAPIModal}>
                                                VIEW APIs
                                            </Button>
                                        ) : (
                                            <>
                                                <img src={DeleteIcon} alt="DeleteIcon" style={{ cursor: 'pointer', marginRight: '15px' }} className="file-delete" onClick={() => save_chat_history(false, 'clear_chat_history')} />
                                                {/* <Button className="to-prod-btn" onClick={toggleAPIModal}>
                                                    RELEASE TO PRODUCTION{" "}
                                                    <FontAwesomeIcon icon={faArrowRight} />
                                                </Button> */}
                                            </>
                                        )}</div>
                                    </div>
                                    <ChatComponent2
                                        conversationList={conversationList}
                                        question_answer={question_answer}
                                        questionsList={questionsList}
                                        chatLoader={chatLoader}
                                        isRecomendationsOptions={false}
                                        isAddOptions={false}
                                        displayCheck={true}
                                        project_main={project_main}
                                        textAreaDisable={
                                            // !getFromSession(KB_NAMES_ENUM.KDB_NAME) ||
                                            // conversationList?.length < 1 ||
                                            project_main?.project_status?.toLocaleLowerCase() === ProjectStatus.PRODUCTION
                                        }
                                        setConversationList={setConversationList}
                                        dontScroll={dontScroll}
                                        setDontScroll={setDontScroll}
                                    />
                                </div>
                                {/* <br></br>
                                <div className="production">
                                    {project_main?.project_status?.toLocaleLowerCase() ===
                                        "production" ? (
                                        <Button className="to-prod-btn" onClick={toggleNewModal}>
                                            CREATE VERSION
                                        </Button>
                                    ) : (
                                        <Button className="to-prod-btn" onClick={toggleAPIModal}>
                                            RELEASE TO PRODUCTION{" "}
                                            <FontAwesomeIcon icon={faArrowRight} />
                                        </Button>
                                    )}
                                </div> */}
                            </div>
                        </div>
                    </TabPane>
                </TabContent>
            </div>
        </div>
    )
}

export default EbookInsightsPage